import PlusIcon from "@/components/icons/PlusIcon";
import {useRef, useState} from "react";
import MinusIcon from "@/components/icons/MinusIcon";
import DOMPurify from 'dompurify';
import {useGSAP} from "@gsap/react";
import {gsap} from "gsap";

export default function AccordionSimple({title, content}) {

    const [open, setOpen] = useState(false)

    const accordion = useRef(null)
    const contentWrapper = useRef(null)

    const {contextSafe} = useGSAP({scope: accordion});

    const toggle = contextSafe(() => {
        if (open) {
            gsap.to(contentWrapper.current, {
                height: 0,
                duration: 0.25
            });
        } else {
            gsap.to(contentWrapper.current, {
                height: 'auto',
                duration: 0.25
            });
        }

        setOpen(!open)
    });

    return (
        <div className={"rounded-lg bg-ice-grey hover:bg-brand-orange-light border border-transparent hover:border-brand-orange overflow-hidden transition-colors"} ref={accordion}>
            <div
                className={"flex items-center cursor-pointer p-[32px] "}
                onClick={toggle}
            >
                <div className={"text-[20px] leading-[30px] font-bold flex-1 mr-[24px]"}>
                    {title}
                </div>
                {open
                    ? <MinusIcon className={"size-[25px]"}/>
                    : <PlusIcon className={"size-[25px]"}/>
                }
            </div>
            <div ref={contentWrapper} className={'h-0 overflow-hidden'}>
                <div
                    className={"ein-accordion-simple p-[32px] [&>:last-child]:mb-0 bg-ice-grey"}
                    dangerouslySetInnerHTML={{'__html': DOMPurify.sanitize(content)}}
                />
            </div>
        </div>
    )


}
